import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row secret-data-certificate" }
const _hoisted_2 = { class: "col span-6 token" }
const _hoisted_3 = { class: "col span-6 crt" }


import DetailText from '@shell/components/DetailText.vue';

export interface Props {
    crt?: string;
    token?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Certificate',
  props: {
    crt: {},
    token: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailText, {
        value: props.token,
        "label-key": "secret.certificate.privateKey",
        conceal: true,
        "conceal-stand-alone": true
      }, null, 8, ["value"])
    ]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(DetailText, {
        value: props.crt,
        "label-key": "secret.certificate.certificate"
      }, null, 8, ["value"])
    ])
  ]))
}
}

})